import { Action } from '@ngrx/store'
import * as FormPostprocessorsTypes from './form-postprocessors.types'
import { FormPostprocessor } from './form-postprocessors.interface'

// Fetch FormPostprocessor Types
export class FetchFormPostprocessorsRequest implements Action {
  readonly type = FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSORS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchFormPostprocessorsSuccess implements Action {
  readonly type = FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSORS_SUCCESS
  constructor(
    public payload: FormPostprocessor[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchFormPostprocessorsFailure implements Action {
  readonly type = FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSORS_FAILURE
  constructor(public payload: any) {}
}

// Fetch
export class FetchFormPostprocessorRequest implements Action {
  readonly type = FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSOR_REQUEST
  constructor(public id: number) {}
}

export class FetchFormPostprocessorSuccess implements Action {
  readonly type = FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSOR_SUCCESS
  constructor(public payload: FormPostprocessor) {}
}

export class FetchFormPostprocessorFailure implements Action {
  readonly type = FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSOR_FAILURE
  constructor(public payload: any) {}
}

// Delete
export class DeleteFormPostprocessorRequest implements Action {
  readonly type = FormPostprocessorsTypes.DELETE_FORM_POSTPROCESSOR_REQUEST
  constructor(public id: number) {}
}

export class DeleteFormPostprocessorSuccess implements Action {
  readonly type = FormPostprocessorsTypes.DELETE_FORM_POSTPROCESSOR_SUCCESS
  constructor() {}
}

export class DeleteFormPostprocessorFailure implements Action {
  readonly type = FormPostprocessorsTypes.DELETE_FORM_POSTPROCESSOR_FAILURE
  constructor(public payload: any) {}
}

// Create
export class CreateFormPostprocessorRequest implements Action {
  readonly type = FormPostprocessorsTypes.CREATE_FORM_POSTPROCESSOR_REQUEST
  constructor(public payload) {}
}

export class CreateFormPostprocessorSuccess implements Action {
  readonly type = FormPostprocessorsTypes.CREATE_FORM_POSTPROCESSOR_SUCCESS
  constructor() {}
}

export class CreateFormPostprocessorFailure implements Action {
  readonly type = FormPostprocessorsTypes.CREATE_FORM_POSTPROCESSOR_FAILURE
  constructor(public payload: any) {}
}

// Update FormPostprocessor Type
export class UpdateFormPostprocessorRequest implements Action {
  readonly type = FormPostprocessorsTypes.UPDATE_FORM_POSTPROCESSOR_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateFormPostprocessorSuccess implements Action {
  readonly type = FormPostprocessorsTypes.UPDATE_FORM_POSTPROCESSOR_SUCCESS
  constructor() {}
}

export class UpdateFormPostprocessorFailure implements Action {
  readonly type = FormPostprocessorsTypes.UPDATE_FORM_POSTPROCESSOR_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = FormPostprocessorsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = FormPostprocessorsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateFormPostprocessorRequest
  | UpdateFormPostprocessorSuccess
  | UpdateFormPostprocessorFailure
  | FetchFormPostprocessorsSuccess
  | FetchFormPostprocessorsFailure
  | FetchFormPostprocessorsRequest
  | FetchFormPostprocessorSuccess
  | FetchFormPostprocessorFailure
  | FetchFormPostprocessorRequest
  | CreateFormPostprocessorRequest
  | CreateFormPostprocessorSuccess
  | CreateFormPostprocessorFailure
  | DeleteFormPostprocessorRequest
  | DeleteFormPostprocessorSuccess
  | DeleteFormPostprocessorFailure
  | SetDefaultData
  | UpdateField
  | FetchFormPostprocessorsRequest
  | FetchFormPostprocessorsSuccess
  | FetchFormPostprocessorsFailure
